import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import ShipmentForm from "components/Shipment/form"
import {
  getByIdShipment,
  updateShipment,
} from "store/shipment/shipment-action"
import { shipmentAction } from "store/shipment/shipment-slice"

const EditShipment = () => {
  document.title = "Edit Shipment"
  const { id } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, error, shipment } = useSelector(state => state.shipment)

  useEffect(() => {
    dispatch(getByIdShipment(id))

    return () => {
      dispatch(shipmentAction.resetState())
    }
  }, [dispatch, id])

  return (
    <ShipmentForm
      formMode={"Edit"}
      onSubmit={values => dispatch(updateShipment(id, values, navigate))}
      loading={loading}
      error={error}
      shipment={shipment}
    />
  )
}

export default EditShipment
